var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0106 41.24C9.64062 41.24 0.390625 31.9899 0.390625 20.6199C0.390625 9.24987 9.64062 0 21.0106 0C32.3806 0 41.6307 9.24987 41.6307 20.6199C41.6307 31.9899 32.3806 41.24 21.0106 41.24ZM21.0106 0.909912C10.1406 0.909912 1.30066 9.74987 1.30066 20.6199C1.30066 31.4899 10.1406 40.3298 21.0106 40.3298C31.8806 40.3298 40.7207 31.4899 40.7207 20.6199C40.7207 9.74987 31.8806 0.909912 21.0106 0.909912Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9922 19.0498L26.6521 21.75C26.5921 22.2 26.2121 22.5398 25.7621 22.5398H21.3921V33.8198C20.9321 33.8598 20.4622 33.8799 19.9922 33.8799C18.9322 33.8799 17.9021 33.7698 16.9121 33.5698V22.5298H13.5521C13.2421 22.5298 12.9922 22.28 12.9922 21.97V18.5898C12.9922 18.2798 13.2421 18.0298 13.5521 18.0298H16.9121V12.97C16.9121 9.85997 19.4221 7.33984 22.5121 7.33984H26.4321C26.7421 7.33984 26.9922 7.5899 26.9922 7.8999V11.2798C26.9922 11.5898 26.7421 11.8398 26.4321 11.8398H23.6322C22.3922 11.8398 21.3921 12.8498 21.3921 14.0898V18.0298H26.1022C26.6422 18.0298 27.0622 18.5098 26.9922 19.0398V19.0498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.badd95fc0c24fbb98570cfeecce973e2.svg";
export { ForwardRef as ReactComponent };